module.exports = __webpack_public_path__ + "img/openbadge-type-3.7506991a.png";